var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"overflow-x":"hidden !important","overflow-y":"hidden !important"},attrs:{"tile":"","flat":""}},[(_vm.isMounted)?_c('v-card',{staticClass:"pb-0 pt-4 px-0",attrs:{"flat":"","tile":""}},[(_vm.isMounted)?_c(_vm.comp,{key:_vm.changed,tag:"component",attrs:{"id":_vm.changed}}):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }